<template>
  <div class="cadastro">
    <div id="voltar">
      <h4>Editar dados</h4>
      <button @click.prevent="handleVoltar('fechar')">
        <img src="@/assets/Frame 523.png" />
      </button>
    </div>
    <form
      class="form"
      @submit.prevent="cadastrarEdicao()"
    >
      <div id="campos-form-container">
        <div id="campos-form">
          <div id="informacoes">
            <div class="mb-3">
              <div class="label-container">
                <label
                  for="nome"
                  class="form-label required"
                  >Nome*</label
                >
              </div>
              <input
                type="text"
                id="nome"
                class="form-control"
                v-model="dados.nome"
                required
              />
            </div>
            <section>
              <div>
                <label
                  for="cpf"
                  class="form-label required"
                  >CPF:</label
                >
                <input
                  type="text"
                  class="form-control"
                  id="cpf"
                  v-model="dados.cpf"
                  placeholder="000.000.000-00"
                  v-maska="'###.###.###-##'"
                />
              </div>
              <div class="form-group">
                <label
                  for="data-nascimento"
                  class="form-label required"
                  >Data de Nascimento:</label
                >
                <input
                  type="date"
                  class="form-control"
                  id="data-nascimento"
                  v-model="dados.dataNascimento"
                />
              </div>
            </section>
            <div class="mb-3">
              <div class="label-container">
                <label
                  for="arquivo"
                  class="form-label"
                  :style="
                    houveAlteracao() && !arquivo
                      ? 'color: #ef4444; font-weight: bold;'
                      : ''
                  "
                >
                  Documento (PDF) <span v-if="houveAlteracao()">*</span>
                </label>
              </div>
              <input
                type="file"
                id="arquivo"
                class="form-control"
                accept=".pdf,application/pdf"
                @change="handleArquivo"
                :style="
                  houveAlteracao() && !arquivo
                    ? 'border-color: #ef4444; box-shadow: 0 0 0 0.15rem rgba(239, 68, 68, 0.25);'
                    : ''
                "
              />
              <span
                v-if="arquivo"
                style="
                  font-size: 13px;
                  color: gray;
                  margin-top: 4px;
                  display: block;
                "
              >
                📄 {{ arquivo.name }}
              </span>
              <span
                v-else-if="houveAlteracao()"
                style="
                  font-size: 12px;
                  color: #ef4444;
                  margin-top: 4px;
                  display: block;
                  font-weight: 500;
                "
              >
                ⚠️ Aguardando documento PDF justificativo...
              </span>
            </div>
            <div id="regras-container">
              <div class="regras-section">
                <div class="section-label">
                  <i class="ti ti-lock"></i>
                  Regras adicionadas
                  <span class="badge-count">{{
                    regrasSelecionadas.length
                  }}</span>
                </div>
                <div class="regras-group">
                  <span
                    v-if="regrasSelecionadas.length === 0"
                    class="empty-hint"
                  >
                    Nenhuma regra adicionada ainda.
                  </span>
                  <div
                    v-for="regra in regrasAdicionadas"
                    :key="regra.id"
                    class="regra-chip ativa"
                    :class="{ editavel: regrasEditaveis.includes(regra.nome) }"
                    @click="toggleRegras(regra)"
                    :title="
                      regrasEditaveis.includes(regra.nome)
                        ? 'Clique para remover esta regra'
                        : 'Regra já adicionada — não pode ser removida'
                    "
                  >
                    <i
                      v-if="!regrasEditaveis.includes(regra.nome)"
                      class="ti ti-check"
                    ></i>
                    {{ formatarEnum(regra.nome) }}
                    <span
                      v-if="regrasEditaveis.includes(regra.nome)"
                      class="chip-btn-remover"
                      >✕</span
                    >
                  </div>
                </div>
              </div>

              <hr class="regras-divider" />

              <div class="regras-section">
                <div class="section-label">
                  <i class="ti ti-circle-plus"></i>
                  Disponíveis para adicionar
                  <span class="badge-count">{{
                    regrasDisponiveis.length
                  }}</span>
                </div>
                <div class="regras-group">
                  <span
                    v-if="regrasDisponiveis.length === 0"
                    class="empty-hint"
                  >
                    Todas as regras foram adicionadas.
                  </span>
                  <div
                    v-for="regra in regrasDisponiveis"
                    class="regra-chip disponivel"
                    :class="{
                      'nao-editavel-disp': !regrasEditaveis.includes(
                        regra.nome
                      ),
                    }"
                    @click="toggleRegras(regra)"
                  >
                    <i
                      class="ti"
                      :class="
                        regrasEditaveis.includes(regra.nome)
                          ? 'ti-plus'
                          : 'ti-lock'
                      "
                    ></i>
                    {{ formatarEnum(regra.nome) }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        id="botoes"
        style="justify-content: center"
      >
        <button
          id="enviar"
          type="submit"
          class="btn btn-primary center"
        >
          Confirmar alterações
        </button>
      </div>
    </form>
  </div>
  <Aviso
    v-if="mostrarAviso"
    :sucesso="sucessoAviso"
    :texto="mensagemAviso"
    @fechar-modal="handleVoltar('fechar-modal')"
  />

  <ModalConfirmarSenha
    :mostrar="modalSenhaVisivel"
    :carregando="verificandoSenha"
    :erro="erroSenha"
    @cancelar="fecharModalSenha"
    @confirmar="onConfirmarSenha"
  />
</template>
<script setup>
import router from "@/router";
import { onMounted, ref, computed, onBeforeMount, onBeforeUnmount } from "vue";
import { vMaska } from "maska/vue";
import { formatarEnum } from "@/utils/FormatarEntradas";
import regrasService from "@/service/regrasService";
import usuariosService from "@/service/usuariosService";
import Aviso from "@/components/common/aviso.vue";
import ModalConfirmarSenha from "@/components/usuarios/ModalConfirmarSenha.vue";

const mostrarAviso = ref(false);
const sucessoAviso = ref(false);
const mensagemAviso = ref("");

const dadosOriginais = ref();

const regrasSelecionadas = ref([]);
const arquivo = ref();

const regrasAdicionadas = computed(() =>
  regras.value.filter((r) => regrasSelecionadas.value.some((s) => s === r.nome))
);

const regrasDisponiveis = computed(() =>
  regras.value.filter(
    (r) => !regrasSelecionadas.value.some((s) => s === r.nome)
  )
);

function estaSelecionada(regra) {
  return regrasSelecionadas.value.some((r) => r === regra.nome);
}

function houveAlteracao() {
  if (!dadosOriginais.value) return false;
  const nomeAlt =
    (dados.value.nome || "").trim() !==
    (dadosOriginais.value.nome || "").trim();
  const cpfAlt =
    (dados.value.cpf || "").replace(/\D/g, "") !==
    (dadosOriginais.value.cpf || "").replace(/\D/g, "");

  // Normalize dates
  const date1 = dados.value.dataNascimento
    ? new Date(dados.value.dataNascimento).toISOString().split("T")[0]
    : "";
  const date2 = dadosOriginais.value.dataNascimento
    ? new Date(dadosOriginais.value.dataNascimento).toISOString().split("T")[0]
    : "";
  const dataAlt = date1 !== date2;

  return nomeAlt || cpfAlt || dataAlt;
}

const dados = ref({
  nome: "",
  cpf: "",
  dataNascimento: "",
  regras: [],
});

const regras = ref([
  {
    id: "e6e759ae-5790-4938-bfd6-de19141eaf37",
    nome: "ADMINISTRADOR",
  },
  {
    id: "4f8df0cf-a915-408b-8905-f786c170bf96",
    nome: "USUARIO",
  },
  {
    id: "e7efc4ee-2168-46f6-8336-615b8b27cc85",
    nome: "PREX",
  },
  {
    id: "bbe7406a-b7b4-4c37-a27b-20b6c905a7a6",
    nome: "COORDENADOR",
  },
  {
    id: "80d0a265-b218-411c-9944-92ab7a5b5db5",
    nome: "COORDENADORIA",
  },
]);

const props = defineProps({
  dadosUsuario: Object,
});

const emits = defineEmits(["fechar-modal"]);

function handleArquivo(event) {
  const file = event.target.files[0];
  if (!file) return;
  arquivo.value = file;
}

function handleVoltar(paginaPai) {
  switch (paginaPai) {
    case "fechar":
      emits("fechar-modal");
      router.go(-1);
      break;
    case "fechar-modal":
      mostrarAviso.value = false;
      if (sucessoAviso.value) {
        emits("fechar-modal");
        router.replace({ query: {} }).then(() => {
          window.location.reload();
        });
      }
      break;
    default:
      break;
  }
}

const regrasEditaveis = ["COORDENADORIA", "PREX", "ADMINISTRADOR"];

function toggleRegras(regra) {
  if (!regrasEditaveis.includes(regra.nome)) return;

  const index = regrasSelecionadas.value.indexOf(regra.nome);
  if (index > -1) {
    regrasSelecionadas.value.splice(index, 1);
  } else {
    regrasSelecionadas.value.push(regra.nome);
  }
}

const modalSenhaVisivel = ref(false);
const verificandoSenha = ref(false);
const erroSenha = ref("");

function fecharModalSenha() {
  modalSenhaVisivel.value = false;
  erroSenha.value = "";
}

async function onConfirmarSenha(senha) {
  verificandoSenha.value = true;
  erroSenha.value = "";
  try {
    const valida = await usuariosService.verificarSenha(senha);
    if (!valida) {
      erroSenha.value = "Senha incorreta. Tente novamente.";
      return;
    }
    fecharModalSenha();
    await prosseguirComEdicao();
  } catch (error) {
    erroSenha.value = "Erro ao validar senha.";
  } finally {
    verificandoSenha.value = false;
  }
}

function cadastrarEdicao() {
  const originais = props.dadosUsuario.regras ?? [];
  const regrasParaAdicionar = regrasSelecionadas.value.filter(
    (r) => !originais.includes(r) && regrasEditaveis.includes(r)
  );
  const regrasParaRemover = originais.filter(
    (r) => !regrasSelecionadas.value.includes(r) && regrasEditaveis.includes(r)
  );

  if (regrasParaAdicionar.length > 0 || regrasParaRemover.length > 0) {
    modalSenhaVisivel.value = true;
  } else {
    prosseguirComEdicao();
  }
}

async function prosseguirComEdicao() {
  let alterouRegras = false;
  let errosRegras = [];

  const originais = props.dadosUsuario.regras ?? [];
  const regrasParaAdicionar = regrasSelecionadas.value.filter(
    (r) => !originais.includes(r) && regrasEditaveis.includes(r)
  );
  const regrasParaRemover = originais.filter(
    (r) => !regrasSelecionadas.value.includes(r) && regrasEditaveis.includes(r)
  );

  if (regrasParaAdicionar.length > 0) {
    alterouRegras = true;
    for (const regraNome of regrasParaAdicionar) {
      const regraObj = regras.value.find((r) => r.nome === regraNome);
      const regraId = regraObj ? regraObj.id : null;
      const status = await usuariosService.adicionarRegraGenerica(
        dados.value.id,
        regraId,
        regraNome
      );
      if (status !== 200 && status !== 201) {
        errosRegras.push(`Erro ao adicionar regra ${formatarEnum(regraNome)}`);
      }
    }
  }

  if (regrasParaRemover.length > 0) {
    alterouRegras = true;
    let byUnidade = regrasParaRemover.includes("COORDENADORIA");
    let byPrex = regrasParaRemover.includes("PREX");
    let byAdmin = regrasParaRemover.includes("ADMINISTRADOR");

    if (byAdmin) {
      byUnidade = true;
      byPrex = true;
    }

    const status = await usuariosService.rebaixarCoordenador(
      dados.value.id,
      byUnidade,
      byPrex,
      byAdmin
    );
    if (status !== 200 && status !== 204) {
      errosRegras.push("Erro ao remover regras.");
    }
  }

  let alterouCadastro = houveAlteracao();
  let statusCadastro = 200;
  if (alterouCadastro) {
    if (!arquivo.value) {
      sucessoAviso.value = false;
      mensagemAviso.value =
        "Para alterar dados pessoais (Nome, CPF ou Data de Nascimento), você precisa anexar um documento justificativo em PDF.";
      mostrarAviso.value = true;
      return;
    }
    statusCadastro = await usuariosService.editarPerfilUsuario(
      dados.value,
      arquivo.value,
      dados.value.id
    );
  }

  if (errosRegras.length > 0) {
    sucessoAviso.value = false;
    mensagemAviso.value = errosRegras.join("\n");
  } else if (alterouRegras || alterouCadastro) {
    if (
      statusCadastro === 200 ||
      statusCadastro === 201 ||
      statusCadastro === 204
    ) {
      sucessoAviso.value = true;
      mensagemAviso.value = "Informações editadas com sucesso!";
    } else {
      sucessoAviso.value = false;
      mensagemAviso.value =
        "Ocorreu um erro ao editar as informações. Tente novamente mais tarde.";
    }
  } else {
    sucessoAviso.value = false;
    mensagemAviso.value = "Nenhuma alteração foi realizada.";
  }

  mostrarAviso.value = true;
}

onMounted(() => {
  dados.value = { ...props.dadosUsuario };
  regrasSelecionadas.value = [...(props.dadosUsuario.regras ?? [])];

  dadosOriginais.value = {
    nome: dados.value.nome,
    cpf: dados.value.cpf,
    dataNascimento: dados.value.dataNascimento,
  };

  document.body.classList.add("modal-aberto");
});

onBeforeUnmount(() => {
  document.body.classList.remove("modal-aberto");
});
</script>
<style scoped>
.form {
  width: 700px;
}

#voltar {
  width: 700px;
}

.form-label.required::before {
  content: "*";
  color: #5b3fa8;
}

#regras-container {
  margin-top: 15px;
}

#regras {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 10px;
}

#informacoes {
  width: 100%;
}

#informacoes > section {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 10px;
}

#informacoes > section > div {
  width: 40%;
}

.regra {
  padding: 10px 15px;
  border: 1px solid var(--roxo-claro);
  border-radius: 10px;
  cursor: pointer;
}

.regra-ativa {
  background-color: var(--roxo-claro);
  color: #fff;
  font-weight: 500;
}

.regras-section {
  margin-top: 12px;
}

.section-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 500;
  color: black;
  text-transform: uppercase;
  margin-bottom: 8px;
}

.badge-count {
  font-size: 11px;
  font-weight: 500;
  background: #f3f4f6;
  color: #6b7280;
  border: 1px solid #e5e7eb;
  border-radius: 20px;
  padding: 1px 7px;
  text-transform: none;
  letter-spacing: 0;
}

.regras-group {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 8px;
  min-height: 36px;
}

.regra-chip {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 6px 13px;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 500;
  border: 1px solid;
  transition: all 0.15s ease;
  user-select: none;
}

.regra-chip.ativa {
  background-color: var(--roxo-claro-10, #eeedfe);
  border-color: var(--roxo-claro);
  color: var(--roxo-escuro, #3c3489);
  cursor: default;
}

.regra-chip.ativa.editavel {
  cursor: pointer;
}

.regra-chip.ativa.editavel:hover {
  background-color: #fee2e2;
  border-color: #f87171;
  color: #b91c1c;
}

.chip-btn-remover {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background-color: rgba(60, 52, 137, 0.15);
  font-size: 8px;
  margin-left: 6px;
  transition: all 0.15s ease;
  color: var(--roxo-escuro, #3c3489);
  font-weight: bold;
}

.regra-chip.ativa.editavel:hover .chip-btn-remover {
  background-color: #ef4444;
  color: white;
}

.regra-chip.disponivel {
  background-color: transparent;
  border-color: #d1d5db;
  color: inherit;
  cursor: pointer;
}

.regra-chip.disponivel.nao-editavel-disp {
  cursor: not-allowed;
  opacity: 0.6;
}

.regra-chip.disponivel.nao-editavel-disp:hover {
  border-color: #d1d5db;
  background-color: transparent;
  color: inherit;
}

.regra-chip.disponivel:not(.nao-editavel-disp):hover {
  border-color: var(--roxo-claro);
  background-color: var(--roxo-claro-10, #eeedfe);
  color: var(--roxo-escuro, #3c3489);
}

.regras-divider {
  border: none;
  border-top: 1px solid #e5e7eb;
  margin: 14px 0;
}

.empty-hint {
  font-size: 13px;
  color: #9ca3af;
  font-style: italic;
  padding: 4px 0;
}
</style>
